import React from 'react'
import { View, StyleSheet, Text } from 'react-native'
import { IconSuccess } from '../../../../assets/icons'
import { useTranslation } from 'react-i18next'

export const InvoiceIsPaidInfo = ({ isWeb }) => {
  const { t } = useTranslation('global')

  return (
    <View
      style={[styles.container, isWeb ? { marginTop: 60 } : { marginTop: 90 }]}
      testID={'invoice-is-paid-container'}
    >
      <IconSuccess />
      <View style={styles.textsContainer} testID={'invoice-is-paid-message'}>
        <Text style={styles.mainText} testID={'invoice-is-paid-main-text'}>
          {t('quickbooks.invoice-is-paid')}
        </Text>
        <Text style={styles.infoText} testID={'invoice-is-paid-info-text'}>
          {t('quickbooks.no-further-actions')}
        </Text>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: 20,
  },
  textsContainer: {
    marginTop: 30,
  },
  mainText: {
    fontFamily: 'Inter',
    fontSize: 24,
    fontWeight: '700',
    lineHeight: 32,
    textAlign: 'center',
    color: '#19262F',
    width: 300,
  },
  infoText: {
    marginTop: 8,
    fontFamily: 'Inter',
    fontSize: 16,
    fontWeight: '400',
    lineHeight: 32,
    textAlign: 'center',
    color: '#19262F',
  },
})
